import { create } from 'zustand';
import dayjs from 'dayjs';
import { fetchSeriesRotationsList } from '@libs/api/shifts';
import { SeriesRotationsItem } from '@libs/models/shifts';
import { TIMEZONE_FALLBACK } from '@libs/config';
import { ShiftFilter } from '@libs/models/shifts/shift';

type State = {
  loading: boolean;
  initiated: boolean;
  data: SeriesRotationsItem[];
  page: number;
  total: number;
  perPage: number;
  load: (page: number, perPage: number, filter?: ShiftFilter) => Promise<void>;
  lastFilter?: ShiftFilter;
  setPagination: (page: number, perPage: number) => void;
};

export const useSeriesNRotationsListStore = create<State>()((set, get) => ({
  loading: false,
  initiated: false,
  data: [],
  page: 1,
  perPage: 15,
  total: 0,
  load: async (page, perPage, filter) => {
    set({ loading: true, lastFilter: filter });
    try {
      const response = await fetchSeriesRotationsList(page, perPage, {
        ...filter,
        // When date filter is `All`, we should start from the beginning of current day
        startDate: filter?.startDate ?? dayjs().startOf('day').toServerDateTimeFormat(),
        endDate: filter?.endDate ?? undefined,
        timeZone: filter?.timeZone ?? TIMEZONE_FALLBACK,
      });
      set({
        loading: false,
        data: response.items,
        page: response.pageNumber,
        perPage: response.pageSize,
        total: response.totalCount,
      });
    } finally {
      set({ loading: false, initiated: true });
    }
  },
  reload: async () => {
    const { load, page, perPage, lastFilter } = get();
    return load(page, perPage, lastFilter);
  },
  currentShift: null,
  showDetails: false,
  setPagination: (page, perPage) => {
    set({ page, perPage });
  },
}));
